import React, {memo} from 'react'
import {Pagination} from 'semantic-ui-react'
import {withNavigation} from '../../hoc'
import {drop, take, isNil} from 'lodash'
import {Header} from 'semantic-ui-react'

const _Paged = (
  {
    items = [],
    noItemsContent = (<div>No items found</div>),
    totalCount,
    pageSize = 10,
    location,
    navigate,
    query,
    render = () => {
    }
  }
) => {
  const onPaginationChange = (e, {activePage}) => {
    navigate(location.pathname, {query: {...query, activePage}})
  }
  const isTotalCountSet = !isNil(totalCount)
  totalCount = !isTotalCountSet ? items.length : totalCount
  let activePage = parseInt(query.activePage || '1')
  const totalPageCount = totalCount <= pageSize ? 1 : Math.ceil(totalCount / pageSize)
  const skip = activePage === 1 ? 0 : (activePage - 1) * pageSize
  const visibleItems = !isTotalCountSet ? take(drop(items, skip), pageSize) : items

  if (activePage > totalPageCount) {
    navigate(location.pathname, {query: {...query, activePage: totalPageCount}})
    return null
  }

  if (visibleItems.length === 0) {
    return noItemsContent
  }

  return (
    <>
      {
        visibleItems.length > 0 && (
          <Header as='h4' style={{marginBottom: '25px'}} dividing>
            Displaying {skip + 1}-{skip + pageSize > totalCount ? totalCount : skip + pageSize} of {totalCount}
          </Header>
        )
      }
      <div style={{marginBottom: '25px'}}>
        {render({page: visibleItems})}
      </div>
      {
        totalPageCount > 1 && (
          <Pagination activePage={activePage} totalPages={totalPageCount} onPageChange={onPaginationChange}/>
        )
      }
    </>
  )
}

let Paged = (props) => {
  return (<_Paged {...props}/>)
}

Paged = withNavigation(Paged)
Paged = memo(Paged)

export {Paged, _Paged}

export default Paged
